import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "../../utils/httpClient";

const name = "investmentStage";
const initialState = {
  investmentStage: [],
  loading: false,
  error: null,
};

export const fetchInvestmentStage = createAsyncThunk(
  "investmentStage/fetchInvestmentStage",
  async () => {
    const data = await axiosApi.get(
      `${process.env.REACT_APP_BASE_URL}investmentStage`
    );
    return data.data;
  }
);

const investmentStageSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchInvestmentStage.pending, (state) => {
      state.investmentStage = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchInvestmentStage.fulfilled, (state, action) => {
      state.investmentStage = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchInvestmentStage.rejected, (state, action) => {
      state.investmentStage = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default investmentStageSlice.reducer;
